import { usePushStream } from '@/common/push/PushStreamContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { createContext, useContext, useEffect, useState } from 'react';
import { usePrincipal } from '../principal/PrincipalContext';
import { useRsrc } from '../rsrc/RsrcContext';

const NotifContext = createContext();

export const NotifProvider = ({ children }) => {
  const [notifs, setNotifs] = useState([]);
  const [notifCount, setNotifCount] = useState(0);

  const { principal, org } = usePrincipal();
  const { isLeaderRef, addListener } = usePushStream();
  const rsrc = useRsrc();

  const refreshNotifCount = () => {
    const rowsReq = {
      expr: ExprUtils.whereParams('username', principal.username, 'ack', false),
    };
    rsrc.rowCount('skdr', 'NOTIF', rowsReq).then(setNotifCount);
  };

  const handleNotifs = (newNotifs) => {
    // Only the tab holding the push stream downloads, so an export is downloaded once per browser
    if (isLeaderRef.current) {
      newNotifs
        .filter((notif) => notif.jobCat === 'EXPORT' && notif.eventType === 'FINISH_SUCCESS' && !notif.ack)
        .forEach((notif) => rsrc.download(notif.event.module, notif.event.data));
    }
    setNotifs(newNotifs);
  };

  useEffect(() => {
    if (!org) return;

    const removeListeners = [
      addListener('notifs', (data) => {
        if (data.org === org) {
          handleNotifs(data.notifs);
        }
      }),
      // Notifications may have been missed while the stream was down
      addListener('connected', refreshNotifCount),
    ];

    return () => removeListeners.forEach((removeListener) => removeListener());
  }, [org, addListener]);

  useEffect(refreshNotifCount, [notifs]);

  return <NotifContext.Provider value={{ notifs, notifCount }}>{children}</NotifContext.Provider>;
};

export const useNotif = () => useContext(NotifContext);
